const NAMESPACE = "pageContextSelector";

const KEYS = {
    changeProgramLinkLabel: "changeProgramLinkLabel"
};

const MESSAGES = {
    [KEYS.changeProgramLinkLabel]: {
        value: "Change Program",
        comment: "Label for the button create a new merge definition"
    }
};

export { KEYS, NAMESPACE, MESSAGES };
